import { motion, useScroll, useSpring, useReducedMotion } from "framer-motion";

/**
 * Thin reading-progress bar pinned to the top of the viewport.
 * Sits under the navbar visually but above page content.
 */
export const ScrollProgress = () => {
  const prefersReduced = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 24,
    restDelta: 0.001,
  });

  if (prefersReduced) return null;

  return (
    <motion.div
      aria-hidden
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 z-[60] h-[2px] origin-left bg-gradient-to-r from-primary via-primary to-accent pointer-events-none"
    />
  );
};

export default ScrollProgress;
